import { createSlice } from "@reduxjs/toolkit";
import { KeysState } from "../entities/interfaces/keys-state.interface";
import getKeysCases from "./cases/get-keys.cases";

const initialState: KeysState = {
  keys: [],
  isLoadingKeys: false
};

const keysSlice = createSlice({
  name: "keys/v2",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    getKeysCases(builder);
  }
});

export default keysSlice.reducer;
